import React, { Component } from 'react'
import { Paragraph, Box, Button } from 'grommet';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
/*import Header from './Header';
import Footer from './Footer';*/


class RiepilogoOTPEmail extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {

        }
        this.redirectSetting = this.redirectSetting.bind(this);
        this.redirectSettingFistStep = this.redirectSettingFistStep.bind(this);
        this.logout = this.logout.bind(this);
        this.redirectHome = this.redirectHome.bind(this);
    }
    redirectSettingFistStep() {
        this.props.firstStep();
    }

    redirectSetting() {
        this.props.history.push('/Setting');
    }

    redirectHome() {
        this.props.history.push('/Home');
    }

    logout() {
        localStorage.clear();
        sessionStorage.clear();
        this.props.history.push('/login')
    }

    render() {
        const outcome = <Box>
            <Box>
                <Box className='contentbox' style={{ height: '483px' }}>
                    <Box direction="column" align='center'>
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>{this.props.values.status === 200 ? "Operazione andata a buon fine!" : "Operazione non andata a buon fine!"}</h1>
                        <Paragraph className='textParagraph' style={{ textAlign: 'center' }}>{this.props.values.status === 200 ? "La modifica è stata effettuata correttamente." : "Spiacenti, la modifica richiesta non è andata a buon fine."}</Paragraph>
                    </Box>
                    {this.props.values.status === 200 ?
                        <Box direction='row' margin='xlarge'>
                            <Box className='informativa' align='center' style={{margin: "0 auto"}}>
                                <Button focusIndicator={false} color='transparent' className='btnform' label='HOME' onClick={this.redirectHome} />
                            </Box>
                        </Box>

                        :
                        <Box direction='row' margin='xlarge'>
                            <Box className='informativa' align='start'>
                                <Button focusIndicator={false} color='transparent' className='btnform' label='Riprova' onClick={this.redirectSettingFistStep} />
                            </Box>
                            <Box className='informativa' align='end'>
                                <Button focusIndicator={false} color='transparent' className='btnform' label='Home' onClick={this.redirectHome} />
                            </Box>
                        </Box>
                    }
                </Box>
            </Box>

        </Box>



        return (
            <Box style={{ margin: window.location.pathname !== '/InsertTelephone' ? '0 auto' : '' }}>
                {outcome}
            </Box>
        )
    }
}

export default withRouter(RiepilogoOTPEmail)